import React from "react";
import { Controller } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./custom.css";

const TextArea = ({ control, id, placeholder }) => {
  const customColors = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#008dce",
    "#00a2e8",
    "#008000",
    "#0000ff",
    "#9900ff",
    "#ff00ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    // "#bbd6ff",
  ];

  return (
    <div className="mb-4">
      <Controller
        name={id}
        control={control}
        defaultValue=""
        rules={{ required: "Field is required" }}
        render={({ field }) => (
          <ReactQuill
            {...field}
            theme="snow"
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ size: ["small", false, "large", "huge"] }],
                [{ color: customColors }, { background: customColors }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "image"],
                ["clean"], // Remove formatting
              ],
            }}
            placeholder={placeholder ?? ""}
          />
        )}
      />
    </div>
  );
};

export default TextArea;
